import { render, staticRenderFns } from "./highlights-card.vue?vue&type=template&id=24820958&scoped=true"
import script from "./highlights-card.vue?vue&type=script&lang=js"
export * from "./highlights-card.vue?vue&type=script&lang=js"
import style0 from "./highlights-card.vue?vue&type=style&index=0&id=24820958&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24820958",
  null
  
)

export default component.exports